// `hasValidIdsForMessagingOrEmpty` / `getCandidateBlacklistedReasonFromId`
// (`extension-alert-candidates.component.ng1.ts:932, 2242`, and the client-contact twins).
//
// Messaging opens the composer for the current selection unless EVERY selected entity is
// unreachable. An empty selection is allowed: the composer opens with no recipients.

/** `AlertBlacklistReason`. */
export const AlertBlacklistReason = { EmailBlacklisted: 'EMAIL_BLACKLISTED', NoEmail: 'NO_EMAIL' } as const
export type AlertBlacklistReason = (typeof AlertBlacklistReason)[keyof typeof AlertBlacklistReason]

/** A row on the current page. */
export interface MessageableRow {
  id: number
  email?: string | null
  emailBlacklisted?: boolean | null
}

/** From the all-results details call, for ids not on the page. */
export interface MessageableDetails {
  id: number
  blacklistReason?: string | null
}

/**
 * ⚠️ A ROW ON THE PAGE IS JUDGED BY ITS OWN FIELDS, NOT BY THE DETAILS CALL. No email is a
 * reason in itself (`NO_EMAIL`), and `emailBlacklisted` is the other; only an id that is not on
 * the page falls back to the details' `blacklistReason`.
 */
export function blacklistReason(
  id: number,
  rows: readonly MessageableRow[],
  details: readonly MessageableDetails[],
): AlertBlacklistReason | string | null {
  const row = rows.find((candidate) => candidate.id === id)
  if (row !== undefined) {
    if (row.email === undefined || row.email === null || row.email === '') return AlertBlacklistReason.NoEmail
    return row.emailBlacklisted === true ? AlertBlacklistReason.EmailBlacklisted : null
  }
  return details.find((entry) => entry.id === id)?.blacklistReason ?? null
}

export function hasValidIdsForMessagingOrEmpty(
  ids: readonly number[],
  rows: readonly MessageableRow[],
  details: readonly MessageableDetails[],
): boolean {
  if (ids.length === 0) return true
  return ids.some((id) => blacklistReason(id, rows, details) === null)
}
